/**
 * Public night logo. Uploaded files live in the venue-logos bucket.
 * Known nights still fall back to the files shipped with the app.
 * @see docs/APP_UI_SPEC.md — F4
 */

export const VENUE_LOGO_BUCKET = 'venue-logos';

const STATIC_LOGOS = {
  sunset: '/images/sunset-comedy-logo.png',
  craicup: '/images/craic-up-comedy.png',
  studio48: '/images/studio48-comedy.png',
  'joke-wranglers': '/images/joke-wranglers-logo.jpg',
};

const LOGO_TYPES = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/gif': 'gif',
};

const MAX_LOGO_BYTES = 2 * 1024 * 1024;

export function venueLogoSrc(venue) {
  const uploaded = String(venue?.logo_url || '').trim();
  if (uploaded) return uploaded;
  return STATIC_LOGOS[venue?.venue_slug] || '/images/default-logo.png';
}

export function logoFileError(file) {
  if (!file) return '';
  if (!LOGO_TYPES[file.type]) return 'Logo must be a JPEG, PNG, WebP, or GIF.';
  if (file.size > MAX_LOGO_BYTES) return 'Logo must be under 2 MB.';
  return '';
}

export function venueLogoObjectPath(slug, file) {
  const ext = LOGO_TYPES[file?.type] || 'jpg';
  return `${String(slug || '').trim()}/logo.${ext}`;
}

export async function uploadVenueLogo(supabase, slug, file) {
  const problem = logoFileError(file);
  if (problem) throw new Error(problem);
  const path = venueLogoObjectPath(slug, file);
  const { error } = await supabase.storage.from(VENUE_LOGO_BUCKET).upload(path, file, {
    upsert: true,
    contentType: file.type,
  });
  if (error) throw error;
  const { data } = supabase.storage.from(VENUE_LOGO_BUCKET).getPublicUrl(path);
  return `${data.publicUrl}?v=${Date.now()}`;
}
